"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _SelectAdapter = _interopRequireDefault(require("../../Adapters/SelectAdapter"));

var _excluded = ["taxoptions", "disabled", "optionsloading"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TaxTypeSelectComponent = function TaxTypeSelectComponent(props) {
  var taxoptions = props.taxoptions,
      disabled = props.disabled,
      optionsloading = props.optionsloading,
      rest = _objectWithoutProperties(props, _excluded);

  if (optionsloading === undefined) {
    optionsloading = false;
  }

  var required = function required(value) {
    return value ? undefined : "Required";
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, _extends({
    required: true,
    fullWidth: true,
    label: "Tax Type",
    name: "taxtype",
    validate: required,
    component: _SelectAdapter.default,
    options: taxoptions,
    loading: optionsloading,
    disabled: disabled,
    subscription: {
      touched: true,
      value: true,
      error: true
    }
  }, rest));
};

var _default = TaxTypeSelectComponent;
exports.default = _default;